export const LoadingStates = {
  Loading: 'loading',
  Rejected: 'rejected',
  Succeeded: 'succeeded',
};
